import { lazy } from "react";
const InquiryManagement = lazy(() => import("@/pages/inquiryManagement/page"));
const PriceComparePage = lazy(
  () => import("@/pages/inquiryManagement/priceCompare/page"),
);

const inquiryRoute = [
  {
    path: "/inquiryManagement",
    name: "询比价管理",
    component: InquiryManagement,
    hideBreadcrumb: true,
    children: [
      {
        path: "/inquiryManagement/priceCompare",
        name: "询比价详情",
        component: PriceComparePage,
      },
    ],
  },
];
export default inquiryRoute;
